import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=04c586b8&shadow"
import script from "./DataTable.vue?vue&type=script&lang=js&shadow"
export * from "./DataTable.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./DataTable.vue?vue&type=style&index=0&id=04c586b8&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports